
/**
* Handle error
*/
export function handleError (selector, closestSelector = '', errors) {
  const element = (typeof selector === 'object') ? selector : selector ? document.querySelector(selector) : ''
  const returnErrors = []

  if (typeof errors === 'object') {
    for (const i in errors) {
      if (typeof errors[i] === 'object') {
        for (const n in errors[i]) {
          returnErrors.push(errors[i][n])
        }
      } else if (errors[i]) {
        returnErrors.push(errors[i])
      } else {
        returnErrors.push(errors)
      }
    }
  } else { 
    returnErrors.push(errors)
  }

  const closestElement = (typeof closestSelector === 'object') ? closestSelector : closestSelector ? document.querySelector(closestSelector) : selector

  let selectorTo = 'body'
  if (closestElement) {
    selectorTo = closestElement
  }
  scrollTo('', selectorTo, -200, element)

  return returnErrors
}

/**
* Start Validate Form
*/
export function startValidateForm (selector, stopValidate = false) { 
  const element = (typeof selector === 'object') ? selector : selector ? document.querySelector(selector) : ''
  if (!stopValidate) {
    element.querySelectorAll('.js-startValidateForm').forEach((item) => {
      item.click()
    })
  }

  return element
}
  
/**
* Validate Form
*/
export function  validateForm (selector, closestSelector = '', valid = true) {
  const element = startValidateForm(selector)

  return new Promise((resolve) => {
    if (valid) {
      resolve()
    } else {
      setTimeout(() => {
        const selectorNew = element.querySelectorAll('.invalid')[0]
        const closestElement = (typeof closestSelector === 'object') ? closestSelector : closestSelector ? document.querySelector(closestSelector) : selectorNew

        let selectorTo = 'body'
        if (closestElement) {
          selectorTo = closestElement
        }

        scrollTo('', selectorTo, -110, selectorTo)
      }, 100)
    }
  })
}
